import React from "react";
import "./App.css";
import Loader from "./components/Loader";

const AppDetails = {
  IOS_APP_STORE_ID: "6476626373",
  ANDROID_PACKAGE_NAME: "app.sam",
  DEEP_LINK_URL: "https://deeplink.aadinathexports.com",
};

function App() {
  React.useEffect(() => {
    let redirectTimeout;

    const handleRedirect = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const isIOS = /iphone|ipad|ipod/.test(userAgent);

      const storeUrl = isIOS
        ? `https://apps.apple.com/app/id${AppDetails.IOS_APP_STORE_ID}`
        : `https://play.google.com/store/apps/details?id=${AppDetails.ANDROID_PACKAGE_NAME}`;

      const openApp = () => {
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = AppDetails.DEEP_LINK_URL;
        document.body.appendChild(iframe);

        redirectTimeout = setTimeout(() => {
          window.location.replace(storeUrl);
        }, 3000);
      };

      document.addEventListener("visibilitychange", () => {
        if (document.hidden) {
          clearTimeout(redirectTimeout);
        }
      });
      openApp();
    };

    handleRedirect();

    return () => {
      clearTimeout(redirectTimeout);
    };
  }, []);

  return <Loader />;
}

export default App;
